import { render, staticRenderFns } from "./PaymentVoucherView.vue?vue&type=template&id=608091ba&"
import script from "./PaymentVoucherView.vue?vue&type=script&lang=js&"
export * from "./PaymentVoucherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports